import axios from 'axios';
import { showError } from '../utils';
import config from '../config';

export function locationSearchResults(authToken, search) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/location/auto-suggest?q=${search}`, {
      headers,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getGyms(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/fitternity/listServices`, body, {
      headers,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getGymProfile(authToken, slug, vendorSlug) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(
      `${config.apiBaseUrl}/fitternity/getServiceDetails?slug=${slug}&vendorSlug=${vendorSlug}`,
      {
        headers,
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getSlots(authToken, serviceId, requestedDate) {
  const headers = {
    authorization: authToken,
    // key: 'zmnnwqalpvimoijyrtpoesit',
  };

  return axios
    .get(
      `${config.apiBaseUrl}/fitternity/getFitternitySlots?serviceId=${serviceId}&date=${requestedDate}`,
      {
        headers,
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getGymBookings(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/fitternity/getAllBookings`, {
      headers,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function bookGymSession(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/fitternity/placeOrder`, body, {
      headers,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function cancelGymSession(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/fitternity/cancelOrder`, body, {
      headers,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function unlockGymSession(authToken, body) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/fitternity/unlockSession`, body, {
      headers,
    })
    .then((response) => {
      if (response.data.status === 'failure')
        return showError({
          data: {
            errorMessage: response.data.errorMessage,
            errorHeader: 'Location Error',
          },
        });
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getSessionId(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/new-auth/login-info?v=1800009282`, {
      headers,
    })
    .then((response) => {
      if (response.data.status === 'failure')
        return showError({
          data: {
            errorMessage: response.data.errorMessage,
            errorHeader: 'Location Error',
          },
        });
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getBooking(authToken, trailId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/fitternity/getBookingDetails/${trailId}`, {
      headers,
    })
    .then((response) => {
      if (response.data.status === 'failure')
        return showError({
          data: {
            errorMessage: response.data.errorMessage,
            errorHeader: 'Location Error',
          },
        });
      return response;
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function getCultPass(authToken, productId) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/rewards/products/${productId}`, {
      headers,
    })
    .then((response) => {
      if (response.data.status === 'failure')
        return showError({
          data: {
            errorMessage: response.data.errorMessage,
            errorHeader: 'Location Error',
          },
        });
      return response;
    })
    .catch((err) => {
      // showError(err);
      throw err;
    });
}

export function renderSplashScreen(authToken) {
  const headers = {
    authorization: authToken,
  };
  return axios
    .get(`${config.apiBaseUrl}/partners/pnb-ml-splash-screen`, {
      headers,
    })
    .then((response) => {
      if (response.data.status === 'failure')
        return showError({
          data: {
            errorMessage: response.data.errorMessage,
            errorHeader: 'Location Error',
          },
        });
      return response;
    });
}
